import React from 'react'
import Icon, {
  LeftOutlined,
  RightOutlined,
  UserOutlined,
  VerticalAlignMiddleOutlined,
} from '@ant-design/icons'
import { Image } from 'antd'
import { ReactComponent as Settings } from '../assets/icons/settings.svg'
import { ReactComponent as Logout } from '../assets/icons/logout.svg'
import { ReactComponent as Open } from '../assets/icons/open_menu.svg'
import { ReactComponent as Close } from '../assets/icons/close_menu.svg'
import { ReactComponent as Notification } from '../assets/icons/notification.svg'
import { ReactComponent as Info } from '../assets/icons/info.svg'
import { ReactComponent as Update } from '../assets/icons/update.svg'
import { ReactComponent as Sort } from '../assets/icons/sort.svg'
import { ReactComponent as History } from '../assets/icons/history.svg'
import { ReactComponent as GroupTitle } from '../assets/icons/group_title.svg'
import { ReactComponent as NameTitle } from '../assets/icons/name_title.svg'
import { ReactComponent as ProjectTitle } from '../assets/icons/project_title.svg'
import { ReactComponent as CustomerTitle } from '../assets/icons/customer_title.svg'
import { ReactComponent as CourseTitle } from '../assets/icons/course_title.svg'
import { ReactComponent as UserTitle } from '../assets/icons/user_title.svg'
import { ReactComponent as ProfileTitle } from '../assets/icons/profile_title.svg'
import { ReactComponent as SettingTitle } from '../assets/icons/setting_title.svg'
import { ReactComponent as InterviewTitle } from '../assets/icons/interview_title.svg'
import { ReactComponent as ActionTable } from '../assets/icons/action_in_table.svg'
import { ReactComponent as Candidate } from '../assets/icons/candidate.svg'
import { ReactComponent as ProfileImg } from '../assets/icons/immagine_profilo.svg'
import { ReactComponent as Objectives } from '../assets/icons/achievement_objectives.svg'
import { ReactComponent as AcrobatReader } from '../assets/icons/acrobat_reader.svg'
import { ReactComponent as Add } from '../assets/icons/add.svg'
import { ReactComponent as AlertInBox } from '../assets/icons/alert_in_box.svg'
import { ReactComponent as Attention } from '../assets/icons/attention.svg'
import { ReactComponent as Edit } from '../assets/icons/edit.svg'
import { ReactComponent as Calendar } from '../assets/icons/calendar.svg'
import { ReactComponent as Cancel } from '../assets/icons/cancel.svg'
import { ReactComponent as Back } from '../assets/icons/back.svg'
import { ReactComponent as Attach } from '../assets/icons/attach.svg'
import { ReactComponent as Copy } from '../assets/icons/copy.svg'
import { ReactComponent as Customize } from '../assets/icons/customize.svg'
import { ReactComponent as CvImported } from '../assets/icons/cv_imported.svg'
import { ReactComponent as CalendarDate } from '../assets/icons/calendar_date.svg'
import { ReactComponent as Birthday } from '../assets/icons/birthday.svg'
import { ReactComponent as Doc } from '../assets/icons/doc.svg'
import { ReactComponent as Docx } from '../assets/icons/docx.svg'
import { ReactComponent as Jpeg } from '../assets/icons/jpeg.svg'
import { ReactComponent as Jpg } from '../assets/icons/jpg.svg'
import { ReactComponent as Pdf } from '../assets/icons/pdf.svg'
import { ReactComponent as Png } from '../assets/icons/png.svg'
import { ReactComponent as Psd } from '../assets/icons/psd.svg'
import { ReactComponent as Txt } from '../assets/icons/txt.svg'
import { ReactComponent as Xls } from '../assets/icons/xls.svg'
import { ReactComponent as Xlsx } from '../assets/icons/xlsx.svg'
import { ReactComponent as Zip } from '../assets/icons/zip.svg'
import { ReactComponent as DocumentGenerate } from '../assets/icons/document_generated.svg'
import { ReactComponent as Document } from '../assets/icons/document.svg'
import { ReactComponent as Download } from '../assets/icons/download.svg'
import { ReactComponent as Email } from '../assets/icons/email.svg'
import { ReactComponent as Fax } from '../assets/icons/fax.svg'
import { ReactComponent as Filter } from '../assets/icons/filter.svg'
import { ReactComponent as Flexibility } from '../assets/icons/flexibility.svg'
import { ReactComponent as Go } from '../assets/icons/go.svg'
import { ReactComponent as Generate } from '../assets/icons/generate.svg'
import { ReactComponent as Import } from '../assets/icons/import.svg'
import { ReactComponent as InfoInBox } from '../assets/icons/info_in_box.svg'
import { ReactComponent as Information } from '../assets/icons/information.svg'
import { ReactComponent as Label } from '../assets/icons/label.svg'
import { ReactComponent as Leadership } from '../assets/icons/leadership.svg'
import { ReactComponent as Linkedin } from '../assets/icons/linkedin.svg'
import { ReactComponent as Load } from '../assets/icons/load.svg'
import { ReactComponent as EditNominative } from '../assets/icons/edit_nominative.svg'
import { ReactComponent as Note } from '../assets/icons/note.svg'
import { ReactComponent as Occupation } from '../assets/icons/occupation.svg'
import { ReactComponent as Clock } from '../assets/icons/clock.svg'
import { ReactComponent as Padlock } from '../assets/icons/padlock.svg'
import { ReactComponent as PassionWork } from '../assets/icons/passion_work.svg'
import { ReactComponent as ArrowRight } from '../assets/icons/arrow_right.svg'
import { ReactComponent as Phone } from '../assets/icons/phone.svg'
import { ReactComponent as Pin } from '../assets/icons/pin.svg'
import { ReactComponent as Location } from '../assets/icons/location.svg'
import { ReactComponent as Privacy } from '../assets/icons/privacy.svg'
import { ReactComponent as ProfessionalGoals } from '../assets/icons/professional_goals.svg'
import { ReactComponent as Projects } from '../assets/icons/projects.svg'
import { ReactComponent as Refresh } from '../assets/icons/refresh.svg'
import { ReactComponent as Trust } from '../assets/icons/trust.svg'
import { ReactComponent as Save } from '../assets/icons/save.svg'
import { ReactComponent as Search } from '../assets/icons/search.svg'
import { ReactComponent as Send } from '../assets/icons/send.svg'
import { ReactComponent as Share } from '../assets/icons/share.svg'
import { ReactComponent as Skills } from '../assets/icons/skills.svg'
import { ReactComponent as Mobile } from '../assets/icons/mobile.svg'
import { ReactComponent as Start } from '../assets/icons/star.svg'
import { ReactComponent as PipeAction } from '../assets/icons/pipe_action.svg'
import { ReactComponent as Success } from '../assets/icons/success.svg'
import { ReactComponent as SwitchOn } from '../assets/icons/switch_on.svg'
import { ReactComponent as SwitchOff } from '../assets/icons/switch_off.svg'
import { ReactComponent as TeamWorking } from '../assets/icons/team_working.svg'
import { ReactComponent as TimeToHire } from '../assets/icons/time_to_hire.svg'
import { ReactComponent as Transfer } from '../assets/icons/transfer.svg'
import { ReactComponent as Upload } from '../assets/icons/upload.svg'
import { ReactComponent as View } from '../assets/icons/view.svg'
import { ReactComponent as ViewOff } from '../assets/icons/view_off.svg'
import { ReactComponent as ViewBoard } from '../assets/icons/view_board.svg'
import { ReactComponent as ViewTable } from '../assets/icons/view_table.svg'
import { ReactComponent as WorkEnvironment } from '../assets/icons/work_environment.svg'
import { ReactComponent as WorkOrganization } from '../assets/icons/work_organization.svg'
import { ReactComponent as Print } from '../assets/icons/print.svg'
import { ReactComponent as UpdateTechnological } from '../assets/icons/update_technological.svg'
import { ReactComponent as ArrowClose } from '../assets/icons/arrow_close.svg'
import { ReactComponent as ArrowOpen } from '../assets/icons/arrow_open.svg'
import { ReactComponent as ArrowOpenRight } from '../assets/icons/arrow_open_right.svg'
import { ReactComponent as Contract } from '../assets/icons/contract.svg'
import { ReactComponent as Graph } from '../assets/icons/graph.svg'
import { ReactComponent as Home } from '../assets/icons/home.svg'
import { ReactComponent as Report } from '../assets/icons/report.svg'
import { ReactComponent as System } from '../assets/icons/system.svg'
import { ReactComponent as Tenant } from '../assets/icons/tenant.svg'
import { ReactComponent as Trash } from '../assets/icons/trash.svg'
import { ReactComponent as Plus } from '../assets/icons/plus.svg'
import { ReactComponent as Minus } from '../assets/icons/minus.svg'
import { ReactComponent as RuotaDestra } from '../assets/icons/ruota_destra.svg'
import { ReactComponent as RuotaSinistra } from '../assets/icons/ruota_sinistra.svg'
import { ReactComponent as LineChartGraph } from '../assets/icons/line-chart-graph.svg'
import { ReactComponent as PencilGraph } from '../assets/icons/pencil.svg'
import { ReactComponent as FolderGraph } from '../assets/icons/folder.svg'
import { ReactComponent as ArrowTopRightGraph } from '../assets/icons/icona_link_esterno.svg'
import { ReactComponent as ViewFigureProfessional } from '../assets/icons/view_figure_professional.svg'
import { ReactComponent as ViewSkills } from '../assets/icons/view_skills.svg'
import { ReactComponent as Globe } from '../assets/icons/globe.svg'
import { ReactComponent as Video } from '../assets/icons/video.svg'
import { ReactComponent as Dataroom } from '../assets/icons/icona_dataroom.svg'
import { ReactComponent as Active } from '../assets/icons/active_icon.svg'
import { ReactComponent as Disabled } from '../assets/icons/disabled_icon.svg'
import { ReactComponent as DocumentsMenu } from '../assets/icons/icona_documenti.svg'
import { ReactComponent as CoursesMenu } from '../assets/icons/icona_corsi.svg'
import { ReactComponent as SkillsMenu } from '../assets/icons/icona_competenze.svg'
import { ReactComponent as GroupAction } from '../assets/icons/group_action.svg'
import { ReactComponent as StatusAction } from '../assets/icons/status_action.svg'
import { ReactComponent as InfoFilled } from '../assets/icons/info_filled.svg'
import { ReactComponent as Support } from '../assets/icons/support.svg'
import { ReactComponent as InfoNote } from '../assets/icons/info_note.svg'

export const ArrowCloseIcon = props => <Icon component={ArrowClose} {...props} />
export const InfoNoteIcon = props => <Icon component={InfoNote} {...props} />
export const ArrowOpenIcon = props => <Icon component={ArrowOpen} {...props} />
export const ArrowOpenRightIcon = props => <Icon component={ArrowOpenRight} {...props} />
export const ContractIcon = props => <Icon component={Contract} {...props} />
export const GraphIcon = props => <Icon component={Graph} {...props} />
export const HomeIcon = props => <Icon component={Home} {...props} />
export const ReportIcon = props => <Icon component={Report} {...props} />
export const SystemIcon = props => <Icon component={System} {...props} />
export const TenantIcon = props => <Icon component={Tenant} {...props} />

export const SettingsIcon = props => <Icon component={Settings} {...props} />
export const SortIcon = props => <Icon component={Sort} {...props} />
export const LogoutIcon = props => <Icon component={Logout} {...props} />
export const OpenMenuIcon = props => <Icon component={Open} {...props} />
export const CloseMenuIcon = props => <Icon component={Close} {...props} />

export const NotificationIcon = props => <Icon component={Notification} {...props} />
export const InfoIcon = props => <Icon component={Info} {...props} />
export const UpdateIcon = props => <Icon component={Update} {...props} />
export const TrashIcon = props => <Icon component={Trash} {...props} />
export const LinkIcon = props => <Icon component={Share} {...props} />
export const ArrowTopRightIcon = props => <Icon component={ArrowTopRightGraph} {...props} />
export const PipeActionIcon = props => <Icon component={PipeAction} {...props} />

export const MapMarkerIcon = props => <i className={`fa fa-map-marker ${props.className}`} />
export const KeyIcon = props => <i className={`fa fa-key ${props.className}`} {...props} />
export const MergeIcon = props => <VerticalAlignMiddleOutlined {...props} />

export const UserIcon = props => <UserOutlined {...props} />

export const HistoryIcon = props => <Icon component={History} {...props} />

export const GroupTitleIcon = props => <Icon component={GroupTitle} {...props} />
export const NameTitleIcon = props => <Icon component={NameTitle} {...props} />
export const ProjectTitleIcon = props => <Icon component={ProjectTitle} {...props} />
export const CustomerTitleIcon = props => <Icon component={CustomerTitle} {...props} />
export const CourseTitleIcon = props => <Icon component={CourseTitle} {...props} />
export const UserTitleIcon = props => <Icon component={UserTitle} {...props} />
export const ProfileTitleIcon = props => <Icon component={ProfileTitle} {...props} />
export const SettingTitleIcon = props => <Icon component={SettingTitle} {...props} />
export const InterviewTitleIcon = props => <Icon component={InterviewTitle} {...props} />

export const ActionTableIcon = props => <Icon component={ActionTable} {...props} />
export const CandidateIcon = props => <Icon component={Candidate} {...props} />
export const ProfileIcon = props => <Icon component={ProfileImg} {...props} />
export const PrintIcon = props => <Icon component={Print} {...props} />
export const ObjectivesIcon = props => <Icon component={Objectives} {...props} />
export const AcrobatReaderIcon = props => <Icon component={AcrobatReader} {...props} />
export const AddIcon = props => <Icon component={Add} {...props} />
export const AlertInBoxIcon = props => <Icon component={AlertInBox} {...props} />
export const AttentionIcon = props => <Icon component={Attention} {...props} />
export const EditIcon = props => <Icon component={Edit} {...props} />
export const CalendarIcon = props => <Icon component={Calendar} {...props} />
export const CancelIcon = props => <Icon component={Cancel} {...props} />
export const LineChartGraphIcon = props => <Icon component={LineChartGraph} {...props} />
export const SquareIcon = props => <i {...props} className={`fa fa-square ${props.className}`} />
export const FolderIcon = props => <Icon component={FolderGraph} {...props} />
export const PencilIcon = props => <Icon component={PencilGraph} {...props} />
export const BackIcon = props => <Icon component={Back} {...props} />
export const AttachIcon = props => <Icon component={Attach} {...props} />
export const CopyIcon = props => <Icon component={Copy} {...props} />
export const CustomizeIcon = props => <Icon component={Customize} {...props} />
export const CvImportedIcon = props => <Icon component={CvImported} {...props} />
export const CalendarDateIcon = props => <Icon component={CalendarDate} {...props} />
export const BirthdayIcon = props => <Icon component={Birthday} {...props} />

export const DocIcon = props => <Icon component={Doc} {...props} />
export const DocxIcon = props => <Icon component={Docx} {...props} />
export const JpegIcon = props => <Icon component={Jpeg} {...props} />
export const JpgIcon = props => <Icon component={Jpg} {...props} />
export const PdfIcon = props => <Icon component={Pdf} {...props} />

export const PsdIcon = props => <Icon component={Psd} {...props} />
export const PngIcon = props => <Icon component={Png} {...props} />
export const TxtIcon = props => <Icon component={Txt} {...props} />
export const XlsIcon = props => <Icon component={Xls} {...props} />
export const XlsxIcon = props => <Icon component={Xlsx} {...props} />
export const ZipIcon = props => <Icon component={Zip} {...props} />

export const CupIcon = props => <Image src={'resources/images/coppa.png'} {...props} />

export const DocumentGenerateIcon = props => <Icon component={DocumentGenerate} {...props} />
export const DocumentIcon = props => <Icon component={Document} {...props} />
export const DownloadIcon = props => <Icon component={Download} {...props} />
export const PdfIconcon = props => <Icon component={Pdf} {...props} />
export const EmailIcon = props => <Icon component={Email} {...props} />
export const FaxIcon = props => <Icon component={Fax} {...props} />
export const FilterIcon = props => <Icon component={Filter} {...props} />
export const FlexibilityIcon = props => <Icon component={Flexibility} {...props} />
export const GoIcon = props => <Icon component={Go} {...props} />
export const GenerateIcon = props => <Icon component={Generate} {...props} />
export const ImportIcon = props => <Icon component={Import} {...props} />
export const InfoInBoxIcon = props => <Icon component={InfoInBox} {...props} />
export const InformationIcon = props => <Icon component={Information} {...props} />
export const LabelIcon = props => <Icon component={Label} {...props} />
export const LeadershipIcon = props => <Icon component={Leadership} {...props} />
export const LinkedinIcon = props => <Icon component={Linkedin} {...props} />
export const LoadIcon = props => <Icon component={Load} {...props} />
export const EditNominativeIcon = props => <Icon component={EditNominative} {...props} />
export const NoteIcon = props => <Icon component={Note} {...props} />
export const OccupationIcon = props => <Icon component={Occupation} {...props} />
export const ClockIcon = props => <Icon component={Clock} {...props} />
export const PadlockIcon = props => <Icon component={Padlock} {...props} />
export const PassionWorkIcon = props => <Icon component={PassionWork} {...props} />
export const ArrowRightIcon = props => <Icon component={ArrowRight} {...props} />
export const PhoneIcon = props => <Icon component={Phone} {...props} />
export const PinIcon = props => <Icon component={Pin} {...props} />
export const LocationIcon = props => <Icon component={Location} {...props} />
export const PrivacyIcon = props => <Icon component={Privacy} {...props} />
export const ProfessionalGoalsIcon = props => <Icon component={ProfessionalGoals} {...props} />
export const ProjectsIcon = props => <Icon component={Projects} {...props} />
export const RefreshIcon = props => <Icon component={Refresh} {...props} />
export const TrustIcon = props => <Icon component={Trust} {...props} />
export const SaveIcon = props => <Icon component={Save} {...props} />
export const SearchIcon = props => <Icon component={Search} {...props} />
export const SendIcon = props => <Icon component={Send} {...props} />
export const ShareIcon = props => <Icon component={Share} {...props} />
export const SkillsIcon = props => <Icon component={Skills} {...props} />
export const MobileIcon = props => <Icon component={Mobile} {...props} />
export const StartIcon = props => <Icon component={Start} {...props} />
export const SuccessIcon = props => <Icon component={Success} {...props} />
export const SwitchOnIcon = props => <Icon component={SwitchOn} {...props} />
export const SwitchOffIcon = props => <Icon component={SwitchOff} {...props} />
export const TeamWorkingIcon = props => <Icon component={TeamWorking} {...props} />
export const TimeToHireIcon = props => <Icon component={TimeToHire} {...props} />
export const TransferIcon = props => <Icon component={Transfer} {...props} />
export const UploadIcon = props => <Icon component={Upload} {...props} />
export const ViewIcon = props => <Icon component={View} {...props} />
export const ViewOffIcon = props => <Icon component={ViewOff} {...props} />
export const ViewBoardIcon = props => <Icon component={ViewBoard} {...props} />
export const ViewTableIcon = props => <Icon component={ViewTable} {...props} />
export const WorkEnvironmentIcon = props => <Icon component={WorkEnvironment} {...props} />
export const WorkOrganizationIcon = props => <Icon component={WorkOrganization} {...props} />
export const UpdateTechnologicalIcon = props => <Icon component={UpdateTechnological} {...props} />
export const LeftIcon = props => <LeftOutlined {...props} />
export const RightIcon = props => <RightOutlined {...props} />
export const PlusIcon = props => <Icon component={Plus} {...props} />
export const MinusIcon = props => <Icon component={Minus} {...props} />
export const RuotaDestraIcon = props => <Icon component={RuotaDestra} {...props} />
export const RuotaSinistraIcon = props => <Icon component={RuotaSinistra} {...props} />
export const ViewFigureProfessionalIcon = props => (
  <Icon component={ViewFigureProfessional} {...props} />
)
export const ViewSkillsIcon = props => <Icon component={ViewSkills} {...props} />
export const GlobeIcon = props => <Icon component={Globe} {...props} />
export const VideoIcon = props => <Icon component={Video} {...props} />
export const DataroomIcon = props => <Icon component={Dataroom} {...props} />
export const ActiveIcon = props => <Icon component={Active} {...props} />
export const DisabledIcon = props => <Icon component={Disabled} {...props} />
export const DocumentsMenuIcon = props => <Icon component={DocumentsMenu} {...props} />
export const CoursesMenuIcon = props => <Icon component={CoursesMenu} {...props} />
export const SkillsMenuIcon = props => <Icon component={SkillsMenu} {...props} />
export const GroupActionIcon = props => <Icon component={GroupAction} {...props} />
export const StatusActionIcon = props => <Icon component={StatusAction} {...props} />
export const InfoFilledIcon = props => <Icon component={InfoFilled} {...props} />
export const SupportIcon = props => <Icon component={Support} {...props} />

export const EmailSentIcon = ({className, ...props}) => (
  <i className={`fa fa-reply ${className}`} {...props} />
)

